import React, { useState, useEffect, useRef } from 'react'
import './styles.scss'
import arrow from './../../../images/ico-arrow-blue.svg'

const SelectsWritable = (props) => {
    let [ activeDropdown, setActiveDropdown ] = useState(false);
    let [ value, setValue ] = useState('');
    let [ error, setError ] = useState( false );
    let [ errorText, setErrorText ] = useState();
    let [ searchText, setSearchText ] = useState("");
    let [ load, setLoad ] = useState( false );
    let [ data, setData ] = useState([]);
    let [ clicked, setClicked ] = useState(false);
    let [ activeInput, setActiveInput ] = useState(false);
    let ref = useRef();
    const currentRef = useRef(null);

    useEffect(() => {
        if ( props.data && props.data.length > 0 ) {
            if(props.data.length == 1 && props.data[0].nazwa && (props.data[0].nazwa != value)) {
                //testowo dodałem && (props.data[0].nazwa != value)
                setValue(props.data[0].nazwa);
            }
            if(!load) {
                setLoad(true);
            }

            if(!data || data.length == 0) {
                setData(props.data);
                setActiveDropdown(false);
            }
            // setData(props.data);
            // setActiveDropdown(false);
            // setLoad(true);
        }
      }, [load, props.data])

      useEffect(() => {
        if(load ) {
            if(props.val != value) {
                props.setFunction(value);
            }
        }
      }, [value])

      useEffect(() => {
        if(load) {
            checkResult();
            if(searchText.length == 0) {
                props.setFunction(searchText);
            }
        }
      }, [searchText])

    // set value
    useEffect(() => {
        if ( props.val !== value && props.val !== '') {
            setValue(props.val)
        }
        if ( props.val !== value && props.val === '' ) {
            setValue(props.val)
        }
        setSearchText(props.val);
    }, [props.val])
    
    useEffect(() => {
        if ( load && !activeDropdown) {
            checkValue();
        }
    }, [activeDropdown])

    useEffect(() => {
        if ( load && !activeDropdown) {
            checkValue();
        }
    }, [activeDropdown])
    // force validate again when clicked submit button
    useEffect(() => {
        if ( load ) {
            checkValue();
        }
    }, [props.forceValidate, props.forceValidateItems, props.forceValidateFromName])

    
    useEffect(() => {
        if ( props.errorCheckboxCopy && props.index === 0) {
            checkValue();
        }
    }, [props.errorCheckboxCopy])

    useEffect(() => {
        if ( props.showEmptyError && value === '') {
            checkValue();
        }
    }, [props.showEmptyError, value])

    useEffect(() => {
        if (  value !== '' && props.copyCategories ) {
            checkValue();
        }
    }, [value])


    const checkResult = () => {
        if(searchText.length > 1) {
            let result = [];
            data && data.map(item => {
                // if((item.nazwa).toLowerCase().substring(0, searchText.length) == searchText.toLowerCase()) {
                //     result = [...result, item];
                // }

                if((item.nazwa ? item.nazwa : item.name).toLowerCase().includes(searchText.toLowerCase())) {
                    result = [...result, item];
                }
            })
            if(!clicked) {
                setActiveDropdown( props.disabled ? false : true) 
            }
            setClicked(false);
            setData(result);
        }else{
            setData(props.data);
        } 
    }

    let checkValue = () => {
        if ( value.length === 0 ) {
            setErrorText('Required')
            setError(true);
        } else {
            setError(false);
            if( props.forceValidateFromName ) {
                props.setForceValidateFromName(false);
            }
        }
        return false;
    } 

    const handleClickOutside = (event) => {
        if (currentRef.current && !currentRef.current.contains(event.target)) {
            setActiveDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={"select-wrapper " + ( error ? 'error-item' : '')} >
            {props.label &&
                <p className="label" onClick={() => {setActiveInput(true); ref.current.focus()}}>{props.label}</p>
            }
            <div ref={currentRef} className={"select selects-writable select-columns " + ( activeDropdown ? 'active ' : '') + ( error ? 'error ' : '') + ( (value && value.length > 0 || searchText && searchText.length > 0 || activeInput) ? 'filled ' : '' ) + ( props.disabled || props.disabledInput ? 'disabled-force' : '' ) }>
                <span className="value"> 
                    {/* <span id={props.id ? props.id : ''}>{ value.length === 0 ? 'Rodzaj przedmiotu' : value }</span> */}
                    <input type="text" ref={ref} onChange={(e) => setSearchText(e.target.value)} value={ searchText } placeholder={props.placeholder} onClick={ () => { 
                        if ( props.disabled && props.checkFv ) {
                            props.checkFv();
                        }
                        if(props.data && props.data.length > 1) {
                            setActiveDropdown( props.disabled ? false : !activeDropdown) 
                        }
                    } } />
                    {props.data && props.data.length > 1 &&
                        <div className="icon" onClick={ () => { 
                            if ( props.disabled && props.checkFv ) {
                                props.checkFv();
                            }
                            if(props.data && props.data.length > 1) {
                                setActiveDropdown( props.disabled ? false : !activeDropdown) 
                            }
                        } }>
                            <img src={ arrow } alt="Rozwiń" />
                        </div>
                    }
                </span>
                {props.placehold &&
                    <div className="placeholder" onClick={() => {setActiveInput(true); ref.current.focus()}}>
                        <span className="underline"></span>
                        <span className="text">{ props.placehold }</span>
                    </div>
                }
                <div className="dropdown">
                    <ul className="columns"  style={{ columnCount : data.length == 2 ? 2 : data.length == 1 ? 1 : 3 }}>
                        { data && data.map( (item, index) => (
                            <li key={ index } onClick={() => { setClicked(true); setValue(item.nazwa ? item.nazwa : item.name); setActiveDropdown(false); setSearchText(item.nazwa ? item.nazwa : item.name) } }>{ item.nazwa ? item.nazwa : item.name }</li>
                        ))}
                    </ul>
                </div>
            </div>
            { error && 
                <div className="error-message">
                    { errorText }
                </div>
            }
        </div>
    )
}

export default SelectsWritable;